// @ts-nocheck

import palette from '../palette';

import { withOpacity } from './helpers';

export const MissionFreebetsPotentialGain = {
  backgroundColor: palette.bluegrey925,
  color: palette.white,
};

export const MissionProgressBar = {
  progressBarColor: palette.bluegrey750,
  progressBarBgColor: palette.greenwinamax450,
  bgGradient: palette.progressBarBackground,
  progressBarBoxShadow: withOpacity(palette.greenwinamax450, 'bf'),
};

export const MissionDetailsRulesButton = {
  color: palette.white,
};

export const MissionRequirementTag = {
  backgroundColor: 'rgba(255, 255, 255, 0.05)',
  labelColor: palette.bluegrey350,
  valueColor: palette.white,
};

export const MissionDetailsAchievementProgress = {
  defaultBackgroundColor: palette.bluegrey700,
  defaultBorderColor: palette.bluegrey750,
  completedBackgroundColor: palette.greenwinamax450,
  completedBorderColor: palette.greenwinamax450,
};

export const MissionEnrollmentButton = {
  backgroundGradient: palette.missionEnrollmentButtonBackgroundGradient,
  borderGradient: palette.missionEnrollmentButtonBorderGradient,
  borderHaloGradient: palette.missionEnrollmentButtonBorderHaloGradient,
  color: palette.white,
};

export const MissionDetailsRedirectionButton = {
  backgroundColor: palette.white,
  color: palette.bluegrey925,
};

export const MissionCard = {
  winGreen: palette.greenwinamax450,
  bottomRowBackground: palette.bluegrey950,
  disabled: palette.neutralgrey850,
};

export const MissionBanner = {
  backgroundGradient: `linear-gradient(to right, ${palette.bluegrey900} 0%, rgba(20, 23, 31, 0) 42%)`,
  expandBackgroundColor: 'rgba(255, 255, 255, 0.2)',
};

export const MissionDetailsAchievement = {
  backgroundColor: palette.bluegrey900,
  afterDefaultBackgroundColor: palette.bluegrey800,
  afterWonBackgroundColor: palette.greenwinamax450,
  SRTBackgroundColor: '#0a0b0f',
  SRTColor: '#a9aeb1',
};

export const MissionEligibleHeadband = {
  backgroundColor: palette.bluegrey900,
  backgroundColorDark: palette.black,
  color: palette.white,
};

export const DarkEligibleHeadband = {
  backgroundColor: palette.black,
  color: palette.white,
};

export const MissionTimer = {
  progressBackground: {
    step1: '#29a329',
    step2: '#c2940a',
    step3: '#da500b',
    step4: '#a32929',
    finished: palette.bluegrey400,
  },
};
